// import React, { useState, useEffect } from "react";
// import { Popover, Button, TextField, Box } from "@mui/material";
// import Autocomplete from "@mui/material/Autocomplete";
// import FilterAltIcon from "@mui/icons-material/FilterAlt";
// import { Column, ColumnFiltersState } from "@tanstack/react-table";

// import { toast } from "react-toastify";
// import { ProcurementAxios } from "api/ProcurementAxios";
// import { CustomColumnDef } from "Common/TableContainer";

// interface FilterPopoverProps<TData> {
//   column: Column<TData, unknown>;
//   columnDef: CustomColumnDef<TData>;
//   columnFilters?: ColumnFiltersState;
//   setColumnFilters?: React.Dispatch<React.SetStateAction<ColumnFiltersState>>;
//   setColValue?: any;
//   iconColor?: string;
// }

// const WarehouseModuleFilterPopover = ({
//   column,
//   columnDef,
//   columnFilters,
//   setColumnFilters,
//   setColValue,
//   iconColor,
// }: FilterPopoverProps<any>) => {
//   const filterType = columnDef.filterType;

//   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
//   const [tempValue, setTempValue] = useState(column?.getFilterValue() || "");
//   const [options, setOptions] = useState<any[]>([]);
//   const [loading, setLoading] = useState(false);

//   const open = Boolean(anchorEl);

//   const handleOpen = (e: React.MouseEvent<Element>) => {
//     setAnchorEl(e.currentTarget as HTMLElement);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const handleApply = () => {
//     if (setColValue) {
//       column.setFilterValue(tempValue);
//       setColValue((prev: any) => {
//         const updated = (prev || []).filter(
//           (f: { filterField: string }) => f.filterField !== column.id
//         );
//         return [...updated, { filterField: column.id, filterValue: tempValue }];
//       });
//     }
//     setAnchorEl(null);
//   };

//   const handleClear = () => {
//     column.setFilterValue(undefined);

//     if (setColValue) {
//       setColValue((prev: any) =>
//         (prev || []).filter(
//           (f: { filterField: string }) => f.filterField !== column.id
//         )
//       );
//     }

//     setTempValue("");
//   };

//   useEffect(() => {
//     if (open && columnDef.filterFetchUrl) {
//       const fetchOptions = async () => {
//         setLoading(true);
//         try {
//           const response = await ProcurementAxios.get(columnDef.filterFetchUrl || "");
//           const data: any = response.data;
//           console.log("PR no data", data?.pr_req__pr_req_no
//           );
//           const key = column.id; // e.g. 'pr_req__pr_req_no'
//           const optionsFromResponse = data?.[key] || [];
//           console.log("Column ID is:", column.id);
//           setOptions(optionsFromResponse);
//         } catch (error) {
//           toast.error("Failed to fetch filter options");
//           console.error("Failed to fetch filter options:", error);
//         } finally {
//           setLoading(false);
//         }
//       };

//       fetchOptions();

//       // Set previously applied filter value
//       const appliedFilter = column.getFilterValue();
//       setTempValue(appliedFilter || "");
//     }
//   }, [open, columnDef.filterFetchUrl]);

//   return (
//     <>
//       <FilterAltIcon
//         fontSize="small"
//         onClick={handleOpen}
//         style={{ cursor: "pointer", marginLeft: 6, color: iconColor }}
//       />

//       <Popover
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
//       >
//         <Box p={2} width={250}>
//           {filterType === "dropdown" ? (
//             <Autocomplete
//               sx={{ width: "100%", textTransform: "capitalize" }}
//               size="small"
//               id="filter-autocomplete"
//               loading={loading}
//               options={options || []}
//               value={tempValue || null}
//               getOptionLabel={(option: any) => option?.toString() ?? ""}
//               isOptionEqualToValue={(option: any, value: any) => option === value}
//               onChange={(_, newValue) => {
//                 setTempValue(newValue ?? "");
//               }}
//               renderOption={(props, option: any) => {
//                 const { key, ...rest } = props;
//                 return (
//                   <Box key={key} component="li" {...rest}>
//                     {option?.toString()}
//                   </Box>
//                 );
//               }}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   variant="outlined"
//                   label="Select"
//                   placeholder="Search"
//                 />
//               )}
//             />
//           ) : (
//             <TextField
//               fullWidth
//               label="Search"
//               value={tempValue}
//               onChange={(e) => setTempValue(e.target.value)}
//               size="small"
//             />
//           )}

//           <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
//             <Button size="small" variant="outlined" onClick={handleClear}>
//               Cancel
//             </Button>
//             <Button size="small" variant="contained" onClick={handleApply}>
//               Apply
//             </Button>
//           </Box>
//         </Box>
//       </Popover>
//     </>
//   );
// };

// export default WarehouseModuleFilterPopover;

import React, { useState, useEffect } from "react";
import { Popover, Button, TextField, Box } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Column, ColumnFiltersState } from "@tanstack/react-table";
import { CustomColumnDef } from "./ProjectWarehouseTable";
import { toast } from "react-toastify";
import { WarehouseAxios } from "api/WarehouseAxios";

interface FilterPopoverProps<TData> {
  column: Column<TData, unknown>;
  columnDef: CustomColumnDef<TData>;
  columnFilters?: ColumnFiltersState;
  setColumnFilters?: React.Dispatch<React.SetStateAction<ColumnFiltersState>>;
  setColValue?: any;
  iconColor?: string;
}

interface DropDownResponse {
  label: string;
  value: string;
}

const ProjectWarehouseFilterPopover = ({
  column,
  columnDef,
  columnFilters,
  setColumnFilters,
  setColValue,
  iconColor,
}: FilterPopoverProps<any>) => {
  const filterType = columnDef.filterType;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [tempValue, setTempValue] = useState(column?.getFilterValue() || "");
  const [name, setName] = useState<string>("name");

  const [options, setOptions] = useState<any[]>([]);
  const [isLoading, setLoading] = useState(false);

  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<Element>) => {
    setAnchorEl(e.currentTarget as HTMLElement);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleApply = () => {
    if (setColValue) {
      column.setFilterValue(tempValue);
      setColValue((prev: any) => {
        const updated = (prev || []).filter(
          (f: { filterField: string }) => f.filterField !== column.id
        );
        return [...updated, { filterField: column.id, filterValue: tempValue }];
      });
    }
    setAnchorEl(null);
  };

  const handleClear = () => {
    column.setFilterValue(undefined);

    if (setColValue) {
      setColValue((prev: any) =>
        (prev || []).filter(
          (f: { filterField: string }) => f.filterField !== column.id
        )
      );
    }

    setTempValue("");
  };

  useEffect(() => {
    const appliedFilter = column.getFilterValue();
  }, []);
  useEffect(() => {
    if (open && columnDef.filterFetchUrl) {
      const fetchOptions = async () => {
        setLoading(true);
        try {
          console.log(
            "Fetching options for filter: ",
            columnDef.filterFetchUrl
          );
          const response = await WarehouseAxios.get(
            columnDef.filterFetchUrl || ""
          );

          const data: any = response.data.data;
          setOptions(data);
        } catch (error) {
          toast.error("Failed to fetch filter options");
          console.error("Failed to fetch filter options:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchOptions();
      if (open) {
        const appliedFilter = column.getFilterValue();
        setTempValue(appliedFilter || "");
      }
    }
  }, [open, columnDef.filterFetchUrl]);

  return (
    <>
      <FilterAltIcon
        fontSize="small"
        onClick={handleOpen}
        style={{ cursor: "pointer", marginLeft: 6, color: iconColor }}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} width={200}>
          {filterType === "dropdown" ? (
            <Autocomplete
              sx={{ width: "100%", textTransform: "capitalize" }}
              size="small"
              id="filter-autocomplete"
              options={options || []}
              loading={isLoading}
              value={
                options?.find((opt) => opt[column.id] === tempValue) ?? null
              }
              getOptionLabel={(option: any) => option[column.id] || ""}
              isOptionEqualToValue={(option: any, value: any) =>
                option[column.id] === value[column.id]
              }
              onChange={(_, newValue) => {
                setTempValue(newValue?.[column.id] ?? "");
              }}
              renderOption={(props, option: any) => (
                <Box component="li" {...props}>
                  {option[column.id]}
                </Box>
              )}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" label="Select" />
              )}
            />
          ) : (
            <TextField
              fullWidth
              label="Search"
              value={tempValue}
              onChange={(e) => setTempValue(e.target.value)}
              size="small"
            />
          )}

          <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
            <Button size="small" variant="outlined" onClick={handleClear}>
              Cancel
            </Button>
            <Button size="small" variant="contained" onClick={handleApply}>
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default ProjectWarehouseFilterPopover;
